import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { routerNavigationAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { promptOptionActions, resetPromptOptions } from './prompt-option.actions';
import { promptOptionSelectors } from './prompt-option.reducer';

@Injectable({ providedIn: 'root' })
export class PromptOptionEffects {
   defaultFields: string[] = ['name', 'promptId', 'typeId', 'file.fileToken', 'file.fileId', 'isReusable'];

   defaultOrderingOptions: string[] = ['name:asc'];

   staticFilters: string[] = ['Active = true'];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      promptOptionSelectors.selectState,
      'prompts?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      promptOptionActions,
      this.staticFilters
   );

   resetOnNav$ = createEffect(() =>
      this.actions$.pipe(
         ofType(routerNavigationAction),
         map(() => resetPromptOptions())
      )
   );

   constructor(
      private eagerSelectEffects: EagerSelectEffects<AppState>,
      private store: Store,
      private actions$: Actions
   ) {}
}
